import script from "./communityApplyList.vue?vue&type=script&lang=ts&setup=true"
export * from "./communityApplyList.vue?vue&type=script&lang=ts&setup=true"

import "./communityApplyList.vue?vue&type=style&index=0&id=05559b7f&lang=less"

const __exports__ = script;

export default __exports__